import { render } from "./QVPKidsFinalResult.vue?vue&type=template&id=45e01a2c&scoped=true"
import script from "./QVPKidsFinalResult.vue?vue&type=script&lang=js"
export * from "./QVPKidsFinalResult.vue?vue&type=script&lang=js"

import "./QVPKidsFinalResult.vue?vue&type=style&index=0&id=45e01a2c&lang=css"
import "./QVPKidsFinalResult.vue?vue&type=style&index=1&id=45e01a2c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e01a2c"]])

export default __exports__